export default __webpack_public_path__ + "media/images/tenant/howToRentApartment/step_4-2230ed59dc2383585e4b7ca533b63f8b.webp";